'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-song-lyrics',
  _template: html`
<style>
:host {
  display: block;
  margin: 20px 30px;
}
.moskito-lyrics {
  line-height: 2em;
  white-space: pre;
}
.lyrics-section {
  margin-top: 20px;
}
.chorus {
  margin-left: 40px;
}
</style>
<div class="moskito-lyrics">{{process(lyrics)}}</div>
  `,
  properties: {
    lyrics: {
      type: String,
      notify: true
    }
  },
  process: function (lyrics) {
    return stripEmptyLines(stripComments(stripChords(lyrics)))
  }
})
